import { useContext } from 'react';
import type { ThemeContextState } from '../contexts/ThemeContext';
import { ThemeContext } from '../contexts/ThemeContext';

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) return {} as ThemeContextState;
  return context;
};
